export default __webpack_public_path__ + "static/media/categoryScreenBackground.0f90df66.png";